import { z } from "zod";

export const VoidSaleParams = z.object({
    page: z.number().default(1),
    pageSize: z.number().default(10),
    pharmacyID: z.string().optional()
})